<template>
    <div v-show="productsInCart.length">
        <v-dialog :fullscreen="$vuetify.breakpoint.xsOnly" v-model="shoppingCartOpen" max-width="490">
            <template v-slot:activator="{ on }">
                <v-btn v-on="on">
                    <v-icon dark>mdi-cart-outline</v-icon>
                    <v-chip
                            small
                            v-text="numberOfProducts"
                            class="ma-2"
                            color="red"
                            text-color="white"></v-chip>
                </v-btn>
            </template>

            <v-card
                    class="mx-auto"
                    max-width="490">
                <v-card-text class="cart__card-wrapper">
                    <CartItem
                            v-for="(product, index) in productsInCart"
                            :key="index"
                            v-bind:product="product"
                    ></CartItem>
                </v-card-text>
                <v-card-actions class="cart__buttons-right">
                    <v-btn
                            @click="closeCart"
                            outlined
                            color="red"
                            text>
                        Aizvērt
                    </v-btn>
                    <v-btn
                            @click="checkout"
                            outlined
                            class="cart__checkout-btn"
                            text>
                        Pirkt
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { EventBus } from '../../main.js';
    import CartItem from './CartItem.vue'


    export default {
        name: "ShoppingCart",
        components: {
            CartItem
        },
        data() {
            return {
                shoppingCartVisible: false,
                shoppingCartOpen: false,
                productsInCart: [],
            }
        },
        methods: {
            addToCart: function(newProduct){
                newProduct.id =  Math.floor(Math.random() * Math.floor(99999999));
                this.productsInCart.push(Object.assign({}, newProduct));
                EventBus.cart = this.productsInCart;
                EventBus.$emit('shop--added-to-cart', true);
            },
            closeCart: function(){
                this.shoppingCartOpen = false;
            },
            removeFromCart: function(removeProduct){
                this.productsInCart = this.productsInCart.filter(function(product){
                    return product.id !== removeProduct.id;
                })

                EventBus.cart = this.productsInCart;
                
                if(this.productsInCart.length === 0){
                    this.shoppingCartOpen = false;
                }
            },
            clearCart: function(){
                this.productsInCart = [];
            },
//            publishCartContent: function(){
//                EventBus.$emit('publish-cart-content', this.productsInCart);
//            },
            checkout: function(){
                const that = this;
                this.shoppingCartOpen = false;

                this.$router.push('/veikals', function(){
                    // dont hurt me
                    setTimeout(function(){
                        EventBus.$emit('shop--checkout', that.productsInCart);
                    }, 1000);
                }, function(){
                    EventBus.$emit('shop--checkout', that.productsInCart);
                });
            }
        },
        computed: {
            numberOfProducts: function(){
                return this.productsInCart.length
            }
        },
        mounted() {
            EventBus.$on('shop--add-to-cart', this.addToCart);
            EventBus.$on('shop--remove-from-cart', this.removeFromCart);
            EventBus.$on('shop--clear-cart', this.clearCart);
//            EventBus.$on('get-cart-content', this.publishCartContent);
        }
    }
</script>

<style scoped>
    .cart__card-wrapper {
        padding: 10px 10px 20px !important;
    }
    .cart__buttons-right {
        justify-content: flex-end;
        padding: 8px 20px 20px 20px;
    }
    .cart__checkout-btn {
        color: #728a63 !important;
    }
</style>